// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modalIcon[data-v-3b1949ec]{margin:15px auto 25px;width:64px;height:64px;text-align:center;line-height:64px;background:#46bf4a;border-radius:50%}.iconMail[data-v-3b1949ec]{fill:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
